<template>
    <u-text-field-solo-rounded v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-text-field-solo-rounded>
</template>

<script>
import UTextFieldSoloRounded from "@/components/publish/styles/forms/u-text-field-solo-rounded.vue";

export default {
    props: {},
    components: {
        UTextFieldSoloRounded,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
